<template>
    <div class="receipt-list-view">
        <Row type="flex">
            <div class="flex-child">
                选择部门：
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="search.department"
                        @on-change="getCascader"
                        change-on-select></Cascader>
                </span>
            </div>
            <div class="flex-child">
                计划版本：
                <Select v-model="search.version" style="width:100px;">
                    <Option v-for="item in planVersion" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="flex-child">
                计划类型：
                <Select v-model="search.type" style="width:100px;" @on-change="filterPlanType" clearable>
                    <Option v-for="item in planType" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="flex-child">
                <span>计划期：</span>
                <DatePicker
                    v-if="search.type === '01'"
                    type="date"
                    format="yyyy-MM-dd"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === '02'"
                    type="date"
                    :format="'yyyy-MM 第' + queryWeek + '周'"
                    value-format="yyyy-MM-dd"
                    @on-change="weekChange"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === '03'"
                    type="month"
                    format="yyyy-MM"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === '04'"
                    type="year"
                    format="yyyy"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
                <DatePicker
                    v-if="search.type === ''"
                    type="date"
                    format="yyyy-MM-dd"
                    @on-change="filterPeriod"
                    placeholder="请选择"
                    v-model="search.period">
                </DatePicker>
            </div>
            <div class="flex-child">
                <Button type="primary" :loading="checkLoading">
                    <span v-if="!checkLoading" @click="lookSearch">查询</span>
                    <span v-else>查询</span>
                </Button>
            </div>
        </Row>
         <!-- 表格 -->
        <Table :columns="columns" :data="list" :height="600">
            <template slot-scope="{ row }" slot="action">
                <div>
                    <Button size="small"
                        @click="handleClick(row, 1)">查看</Button>
                    <Button size="small" type="primary"
                        v-if="row.projectStatus === '待填报'"
                        @click="handleClick(row, 2)"
                        style="margin-left: 6px;">报价</Button>
                    <Button size="small" type="primary"
                        v-if="row.projectStatus === '待确认'"
                        @click="handleClick(row, 3)"
                        style="margin-left: 6px;">确认</Button>
                    <Button size="small" type="primary"
                        v-if="row.projectStatus === '已发布'"
                        @click="handleClick(row, 4)"
                        style="margin-left: 6px;">供应</Button>
                </div>
            </template>
        </Table>
         <!-- 分页 -->
        <div class="pages-box">
            <Page
                :current="pager.currentPage"
                :total="pager.totalItems"
                show-sizer
                :page-size="pager.pageSize"
                @on-change="getChangePageNum"
                @on-page-size-change="getChangePageSize"/>
        </div>
        <Modal
            class="model-postion-setting"
            v-model="dialog"
            title="确认">
            <div class="history-order">
                <span>确定要吗?</span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="dialog = false">取消</span>
                <span class="his-ok" @click="submit">确定</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { getProjectVersion, getProjectType, getAllProjects, checkProject } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
export default {
    data() {
        const self = this;
        return {
            search: {
                department: [],
                organNo: '',
                version: '',
                type: '',
                period: '',
                cgType: ''
            },
            departmentData: [],
            timeOut: null,
            planVersion: [],
            planType: [],
            queryWeek: '',
            selectPeriod: '',
            checkLoading: false,
            columns: [
                {
                    title: '操作',
                    slot: 'action',
                    width: 180,
                    align: 'center'
                },
                {
                    align: 'left',
                    key: 'organNo',
                    title: '单位',
                    width: 180
                },
                {
                    align: 'left',
                    key: 'projectId',
                    title: '计划单号',
                    width: 200
                },
                {
                    align: 'center',
                    key: 'versionId',
                    render(h, data) {
                        return h('span', self.getArrValue(data.row.versionId, self.planVersion));
                    },
                    title: '计划版本',
                    minWidth: 100
                },
                {
                    align: 'center',
                    key: 'typeId',
                    render(h, data) {
                        return h('span', self.getArrValue(data.row.typeId, self.planType));
                    },
                    title: '计划类型',
                    minWidth: 100
                },
                {
                    align: 'center',
                    key: 'period',
                    title: '计划期',
                    minWidth: 150
                },
                {
                    align: 'center',
                    key: 'projectStatus',
                    title: '状态',
                    minWidth: 100
                }
            ],
            list: [],
            pager: {
                currentPage: 1,
                pageSize: 20,
                totalItems: 0
            },
            dialog: false
        };
    },
    created() {
        this.getAllOrganList();
        this.getProjectVersion();
        this.getProjectType();
    },
    mounted() {
        setTimeout(() => {
            this.getList();
        });
    },
    methods: {
        lookSearch() {
            this.pager.currentPage = 1;
            this.getList();
        },
        getList() {
            this.$apollo.query({
                query: getAllProjects,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                    organNo: this.search.organNo,
                    version: this.search.version,
                    type: this.search.type,
                    period: this.selectPeriod,
                    pageNumber: this.pager.currentPage,
                    pageSize: this.pager.pageSize
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getAllProjects;
                this.list = result.data;
                this.pager = result.pager;
            });
        },
        getChangePageNum(val) {
            this.pager.currentPage = val;
            this.getList();
        },

        // 分页显示条数改变
        getChangePageSize(val) {
            this.pager.pageSize = val;
            this.getList();
        },
        // 表格操作
        handleClick(row, ty) {
            if (ty === 1 || ty === 2) {
                this.$router.push({
                    path: '/index/planDetail',
                    query: {
                        projectId: row.projectId,
                        status: row.projectStatus
                    }
                });
            } else if (ty === 3) {
                // 确认
                this.dialog = true;
                this.$apollo.mutate({
                    mutation: checkProject,
                    context: { useApi1: false },
                    variables: {
                        supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                        projectId: row.projectId
                    }
                }).then(res => {
                    const data = res.data.checkProject;
                    if (data && data.code === 200) {
                        this.dialog = false;
                        this.getList();
                    } else {
                        this.$Notice.open({
                            title: '提交失败',
                            desc: data.message
                        });
                    }
                });
            } else if (ty === 4) {
                // 供应
                this.$router.push({
                    path: '/index/manualBuild/stepSecond',
                    query: {
                        projectId: row.projectId,
                        status: row.projectStatus
                    }
                });
            }
        },
        submit() {},
        // 获取部门列表
        async getAllOrganList() {
            if (this.$store.state.organs.length) {
                this.departmentData = this.$store.state.organs;
                clearTimeout(this.timeOut);
            } else {
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    this.getAllOrganList();
                }, 3000);
            }
        },

        // 选中部门
        getCascader(val) {
            this.search.organNo = val[val.length - 1] || '';
        },
        getProjectVersion() {
            this.$apollo.query({
                query: getProjectVersion,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getProjectVersion;
                result.data.forEach(item => {
                    item.label = item.versionName;
                    item.value = item.versionId;
                });
                this.planVersion = result.data;
            });
        },
        getProjectType() {
            this.$apollo.query({
                query: getProjectType,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getProjectType;
                result.data.forEach(item => {
                    item.label = item.typeName;
                    item.value = item.typeId;
                });
                this.planType = result.data;
            });
        },
        filterPlanType(data) {
            if (data) {
                this.selectPeriod = '';
                this.search.period = '';
                if (data === '02') {
                    this.getDay();
                }
            } else {
                this.search.type = '';
                this.selectPeriod = '';
                this.search.period = '';
            }
        },
        filterPeriod(data) {
            this.selectPeriod = data.replace(/-/g, '');
        },
        // 初始化日期
        getDay() {
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = `0${month}`;
            }
            if (day < 10) {
                day = `0${day}`;
            }
            const nowDay = `${year}-${month}-${day}`;
            this.queryWeek = this.getWeekInMonth(new Date(nowDay));
            this.search.period = `${year}-${month}-${day}`;
            this.selectPeriod = `${year}-${month}-0${this.queryWeek}`;
            this.selectPeriod = this.selectPeriod.replace(/-/g, '');
        },
        weekChange(val) {
            const date = this.search.period.toLocaleDateString().replace(/\//g, '-');
            const date1 = new Date(date);
            const year = date1.getFullYear();
            let month = date1.getMonth() + 1;
            let day = date1.getDate();
            if (month < 10) {
                month = `0${month}`;
            }
            if (day < 10) {
                day = `0${day}`;
            }
            this.search.period = `${year}-${month}-${day}`;
            if (val) {
                this.queryWeek = this.getWeekInMonth(new Date(date));
            }
            this.selectPeriod = `${year}-${month}-0${this.queryWeek}`;
            this.selectPeriod = this.selectPeriod.replace(/-/g, '');
        },
        // 根据日期判断是月的第几周
        getWeekInMonth(t) {
            let newT = t;
            if (newT === undefined || newT === '' || newT === null) {
                newT = new Date();
            } else {
                const nt = new Date();
                nt.setYear(newT.getFullYear());
                nt.setMonth(newT.getMonth());
                nt.setDate(newT.getDate());

                const date = nt.getDate(); // 给定的日期是几号

                nt.setDate(1);
                const d = nt.getDay(); // 1. 得到当前的1号是星期几。
                let fisrtWeekend = d;
                if (d === 0) {
                    fisrtWeekend = 1;
                    // 1号就是星期天
                } else {
                    fisrtWeekend = (7 - d) + 1; // 第一周的周未是几号
                }
                if (date <= fisrtWeekend) {
                    return 1;
                }
                if (date > fisrtWeekend) {
                    return 1 + Math.ceil((date - fisrtWeekend) / 7);
                }
            }
            return '';
        },
        getArrValue(value, arr) {
            let key = '';
            arr.forEach(item => {
                if (value === item.value) {
                    key = item.label;
                }
            });
            return key;
        }
    }
};
</script>

<style scoped lang="stylus">

@import '../../assets/stylus/views/receipt-list.styl'

</style>



// WEBPACK FOOTER //
// src/views/plan/index.vue